module.exports = __webpack_public_path__ + "static/media/contact-hero.430e0562.jpg";